var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-component',{attrs:{"box-props":{
    class: 'content',
    padding: ['medium 0', 'xlarge 0']
  },"limit":"small","layout":"v-stack","spacing":['small','medium']}},[_c('a-heading',{attrs:{"level":"1"}},[_vm._v(" Applied Learning ")]),_c('a-text',[_vm._v(" This is a WIP ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }